import React, { useState } from "react";
import logo from "../Assets/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { ImBlog } from "react-icons/im";
import {
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineUserSwitch,
  AiOutlineUserAdd,
  AiOutlineLogout,
  AiOutlineSetting,
} from "react-icons/ai";

import { useTranslation } from 'react-i18next';
import { useAuth } from "../Context/AuthContext";

function NavBar({ isLaunched }) {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const { isLoggedIn, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  function handleLanguage(language) {
    i18n.changeLanguage(language);
    setLangOpen(false);
  }

  const closeMenu = () => {
    updateExpanded(false);
    setLangOpen(false);
  };

  return (
    <nav
      className={navColour ? "sticky" : "navbar"}
      style={{ position: "fixed", top: 0, width: "100%", zIndex: 1030 }}
    >
      <div className="flex items-center justify-between w-full px-1 md:px-4 py-1.5 md:py-2">
        {/* Brand Logo — always visible on the left */}
        <a href="/" className="flex items-center flex-shrink-0">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </a>

        {/* Hamburger — visible only on mobile, on the right */}
        <button
          className="md:hidden flex flex-col justify-center gap-1.5 p-2 ml-auto -mr-2 bg-transparent border-0 outline-none"
          aria-controls="responsive-navbar-nav"
          aria-expanded={!!expand}
          onClick={() => updateExpanded(expand ? false : "expanded")}
        >
          <span
            className={`block w-6 h-0.5 bg-white transition-all duration-300 ${expand ? "rotate-45 translate-y-2" : ""}`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-white transition-all duration-300 ${expand ? "opacity-0" : ""}`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-white transition-all duration-300 ${expand ? "-rotate-45 -translate-y-2" : ""}`}
          ></span>
        </button>

        {/* Nav Items — dropdown on mobile, inline on desktop */}
        <div
          id="responsive-navbar-nav"
          className={`
            ${expand ? "flex" : "hidden"} md:flex
            flex-col md:flex-row
            items-start md:items-center
            gap-1 md:gap-4
            absolute md:static
            top-full left-0
            w-full md:w-auto
            md:ml-auto
            px-2 md:px-0
            py-3 md:py-0
            bg-gray-900 md:bg-transparent
            shadow-lg md:shadow-none
          `}
        >
          <NavLink
            to="/"
            end
            className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
            onClick={closeMenu}
          >
            <AiOutlineHome style={{ marginBottom: "2px" }} /> {t('Home')}
          </NavLink>

          {/* <Link to="/about" className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0" onClick={closeMenu}>
            <AiOutlineMessage style={{ marginBottom: "2px" }} /> {t('About')}
          </Link> */}

          {isLaunched && (
            <NavLink
              to="/members"
              className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
              onClick={closeMenu}
            >
              <AiOutlineUserSwitch style={{ marginBottom: "2px" }} />{" "}
              {t('Members')}
            </NavLink>
          )}

          {isLaunched && (
            <NavLink
              to="/activity"
              className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
              onClick={closeMenu}
            >
              <ImBlog style={{ marginBottom: "2px", marginRight: "4px" }} />{t('Activity')}
            </NavLink>
          )}

          {/* <Link to="/achiever" className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0" onClick={closeMenu}>
            <ImUserCheck style={{ marginBottom: "2px", marginRight: "4px" }} />{t('Admirable')}
          </Link> */}

          {isAdmin && (
            <NavLink
              to="/admin/add-user"
              className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
              onClick={closeMenu}
            >
              <AiOutlineSetting style={{ marginBottom: "2px" }} />{" "}
              {t('Add Member')}
            </NavLink>
          )}

          {/* {isLoggedIn ? (
            <button
              className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0 bg-transparent border-0 cursor-pointer"
              onClick={() => { logout(); navigate('/login'); closeMenu(); }}
            >
              <AiOutlineLogout style={{ marginBottom: "2px" }} />{" "}
              {t('Logout')}
            </button>
          ) : (
            <>
              <NavLink
                to="/login"
                className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
                onClick={closeMenu}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} />{" "}
                {t('Login')}
              </NavLink>
              <NavLink
                to="/signup"
                className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
                onClick={closeMenu}
              >
                <AiOutlineUserAdd style={{ marginBottom: "2px" }} />{" "}
                {t('Sign Up')}
              </NavLink>
            </>
          )} */}

          <div className="relative w-full md:w-auto">
            <button
              className="nav-link flex items-center gap-1 w-full md:w-auto py-2 md:py-0"
              onClick={() => setLangOpen(!langOpen)}
            >
              {t('Language')} <span className="ml-1">▾</span>
            </button>
            {langOpen && (
              <div className="md:absolute md:right-0 mt-1 bg-gray-800 rounded shadow-lg z-50 min-w-max">
                <button
                  className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                  onClick={() => { handleLanguage("en"); closeMenu(); }}
                >
                  {t('English')}
                </button>
                <button
                  className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700"
                  onClick={() => { handleLanguage("hi"); closeMenu(); }}
                >
                  {t('Hindi')}
                </button>
                {/* <button className="block w-full text-left px-4 py-2 text-white hover:bg-gray-700" onClick={() => handleLanguage("bn")}>বাংলা</button> */}
              </div>
            )}
          </div>

          {/* <a href="https://github.com/ranvirgorai" target="_blank" rel="noreferrer" className="fork-btn-inner">
            <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
            <AiFillStar style={{ fontSize: "1.1em" }} />
          </a> */}
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
